import V1 from '@/system-modules/auth/v1/SysAuthV1'
import { ISysAuthModule } from '@/contracts/system-modules/auth/ISysAuthModule'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import SystemModuleConfig from '@/contracts/system/configs/SystemModuleConfig'

export class SysAuthProvider extends Provider<ISysAuthModule> {
  realizations: Record<string, ISysAuthModule> = {
    v1: V1(),
  }
}
const instance: { module: ISysAuthModule | null } = { module: null }

export function SysAuthProviderModule(): ISysAuthModule {
  const version = SystemModuleConfig.getAuthVersion()

  if(!instance.module){
    instance.module = new SysAuthProvider().module(version)
  }

  return instance.module
}
